import { createContext } from 'react'

import type { ComposerStore } from './composerStore'

/**
 * ComposerContext - Context for accessing the composer store.
 *
 * Separated from ComposerProvider and exported from its own file to support HMR
 */
export const ComposerContext = createContext<ComposerStore | null>(null)
